import React from 'react';
import CreatorPage from '../../features/apps/components/CreatorPage';

/** Creator page when inside app store (authenticated flow). */
const CreatorPageRoute = () => {
  return <CreatorPage fromLanding={false} />;
};

export default CreatorPageRoute;
